import React from 'react';


export interface MyComponentProps {
  // Define your prop types here
  handleChangeInfo?: (info: string) => void
  rHistory: string[]
}

export const ResourceHistory: React.FC<MyComponentProps> = (props) => {
  return (
    <div>
      <p>Resource History</p>
      <ul>
      {
      props.rHistory.slice().reverse().map((res, index) => {
          if (index === 0){
            return <li style={{"fontWeight": "bold"}} className="lbp-span-link" onClick={() => props.handleChangeInfo(res)} key={index}>{index + 1}: {res}</li>
          }
          else {
            return <li className="lbp-span-link" onClick={() => props.handleChangeInfo(res)} key={index}>{index + 1}: {res}</li>
          }
        })
      }
      </ul>
    </div>
  );
}